// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductHit_wrapper__7vwZ5","card":"ProductHit_card__eNhH4"};